<div class="dialog">
  <h3 mat-dialog-title>{{ 'dialog_download_ceu_title' | translate }}</h3>
  <h4>{{ 'dialog_download_ceu_instructions' | translate }}</h4>
  <form>
    <div class="downloadLayout" (click)="downloadExcelForCalculCeuEngins()" style="cursor: pointer" [matTooltip]="'dialog_download_ceu_download' | translate">
      <button type="button" mat-mini-fab class="action-button grey-button-color">
        <mat-icon>download</mat-icon>
      </button>
      <span style="margin-left: 8px; opacity: 0.6">{{ 'dialog_download_ceu_download' | translate }}</span>
    </div>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_close' | translate }}</button>
    </div>
  </form>
</div>
